var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button pa-park-clip-button",class:_vm.additionalClass,attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.handleClickButton}},[_c('PAParkClipIcon'),_c('p',[_vm._v(_vm._s(_vm.buttonText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }